import { useTranslation } from "react-i18next";
import styles from "../LegalIdVerification.module.scss";
import { usePageView } from "../../../shared/analytics/usePageView";
import { trackClicked } from "../../../shared/analytics/events";
import { DOCUMENT_CAPTURE_EVENTS, DOCUMENT_CAPTURE_SECTIONS } from "../../../shared/analytics/documentCaptureEvents";

interface ProcessingScreenProps {
  showSpinner: boolean;
  onHideAnimation: () => void;
}

export function ProcessingScreen({ showSpinner, onHideAnimation }: ProcessingScreenProps) {
  const { t } = useTranslation();
  usePageView(DOCUMENT_CAPTURE_EVENTS.VIEWED.PROCESSING_SCREEN, "section", { section: DOCUMENT_CAPTURE_SECTIONS.PROCESSING });

  const handleToggleAnimation = () => {
    trackClicked(DOCUMENT_CAPTURE_EVENTS.CLICKED.TOGGLE_PROCESSING_ANIMATION, "button", { section: DOCUMENT_CAPTURE_SECTIONS.PROCESSING, targetAction: "toggle" });
    onHideAnimation();
  };

  return (
    <div className={styles.card}>
      <h2 className={styles.processingTitle}>
        {t('legalId.processing.title')}
      </h2>

      {showSpinner && <div className={styles.processingSpinner} />}

      <button
        className={styles.hideAnimationLink}
        onClick={handleToggleAnimation}
      >
        {showSpinner ? t('legalId.processing.hideAnimation') : t('legalId.processing.showAnimation')}
      </button>
    </div>
  );
}
